<ng-template #profileModalBox let-modal>
    <div class="modal-header border-0 pb-0">
        <h5 class="modal-title fw-bold">
            My Profile
        </h5>
        <button type="button" class="btn-sm btn-close" (click)="closeModal()"></button>
    </div>

    <div class="modal-body pt-3">
        <form [formGroup]="profileForm">
            <div class="row">
                <div class="col-6 mb-3">
                    <label class="form-label">First Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="firstName" 
                        placeholder="First name" [class.is-invalid]="firstNameControl?.touched && firstNameControl?.invalid">
                    <div class="text-danger small mt-1" *ngIf="firstNameControl?.touched && firstNameControl?.invalid">
                        First name is required
                    </div>
                </div>
                <div class="col-6 mb-3">
                    <label class="form-label">Last Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="lastName" 
                        placeholder="Last name" [class.is-invalid]="lastNameControl?.touched && lastNameControl?.invalid">
                    <div class="text-danger small mt-1" *ngIf="lastNameControl?.touched && lastNameControl?.invalid">
                        Last name is required
                    </div>
                </div>
            </div>

            <div class="mb-3">
                <label class="form-label">Email</label>
                <input type="email" class="form-control profile-email-input" formControlName="email" readonly>
            </div>

            <div class="password-card border rounded-3 p-3 mb-3">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <div
                            class="password-icon rounded-circle bg-white border d-flex align-items-center justify-content-center me-3">
                            <i class="ph-lock-key text-primary"></i>
                        </div>
                        <div>
                            <div class="fw-semibold small">Password</div>
                            <small class="text-muted">Reset via email link</small>
                        </div>
                    </div>

                    <div class="d-flex flex-column align-items-end">
                        <button type="button" class="btn btn-sm"
                            [class.btn-outline-primary]="!(resetEmailCooldownEnd && resetEmailCooldownEnd > 0)"
                            [class.btn-outline-secondary]="resetEmailCooldownEnd && resetEmailCooldownEnd > 0"
                            (click)="sendPasswordResetEmail()"
                            [disabled]="isSendingResetEmail || (resetEmailCooldownEnd && resetEmailCooldownEnd > 0)">
                            <span *ngIf="isSendingResetEmail" class="spinner-border spinner-border-sm me-1"></span>
                            {{ isSendingResetEmail ? 'Sending' : (resetEmailCooldownEnd && resetEmailCooldownEnd > 0 ?
                            'Link Sent' : 'Send Reset Link') }}
                        </button>

                        <small class="text-muted mt-1" *ngIf="resetEmailCooldownEnd && resetEmailCooldownEnd > 0">
                            <i class="ph-clock-countdown me-1"></i>Resend in {{ cooldownDisplay }}
                        </small>
                    </div>
                </div>

                <div class="d-flex align-items-center mt-2" *ngIf="resetEmailCooldownEnd && resetEmailCooldownEnd > 0">
                    <i class="ph-check-circle text-success me-1"></i>
                    <small class="text-success">Check your inbox for the reset link</small>
                </div>
            </div>
        </form>
    </div>

    <div class="modal-footer border-0 pt-0">
        <app-close-button  (clicked)="closeModal()"></app-close-button>
        <app-base-button btnClass="btn btn-sm btn-primary" icon="ph-floppy-disk"
            [disabled]="profileForm.invalid || isSavingProfile" [loading]="isSavingProfile"
            [loadingText]="'Saving...'"
            (clicked)="saveProfile()">
            Save Changes
        </app-base-button>
    </div>
</ng-template>